import type { ComponentProps } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { medicationRequestQueriesStore } from "@/features/my-meds/api";
import { ConfettiMinimalisticIcon, FullscreenAlert } from "@/shared/ui";

export const RefillRequestSuccessScreenAlert = (
  props: ComponentProps<typeof FullscreenAlert.Root>,
) => {
  const queryClient = useQueryClient();

  const handleBack = () => {
    void queryClient.invalidateQueries({
      queryKey: medicationRequestQueriesStore.medicationRequest._def,
    });
  };

  return (
    <FullscreenAlert.Root {...props}>
      <FullscreenAlert.Content>
        <FullscreenAlert.Header icon={ConfettiMinimalisticIcon}>
          <FullscreenAlert.Title>{t`Submission successful!`}</FullscreenAlert.Title>

          <FullscreenAlert.Description>
            {t`We've received your medication request. If anything else is needed, we'll let you know. Otherwise, we'll start reviewing your request soon!`}
          </FullscreenAlert.Description>
        </FullscreenAlert.Header>

        <FullscreenAlert.Footer>
          <FullscreenAlert.Action asChild onClick={handleBack}>
            <Link to={ROUTES.MY_MEDS}>{t`Back to Home`}</Link>
          </FullscreenAlert.Action>
        </FullscreenAlert.Footer>
      </FullscreenAlert.Content>
    </FullscreenAlert.Root>
  );
};
